<template>
  <div class="appTitle">
    <b-jumbotron
      v-bind:header="appName"
      lead="Genomic data for a wide range of species to study the evolution of symbiosis"
    >
      <b-btn variant="primary">
        <router-link tag="div" to="/about">More info</router-link>
      </b-btn>
    </b-jumbotron>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ApplicationTitle",
  computed: mapState([
    // map this.appName to store.state.appName
    "appName"
  ])
};
</script>

<style>
.appTitle {
  margin: 5px;
}
</style>
